import axios from "axios";

// export const BASE_URL = "https://madeinheavenserver-production.up.railway.app/";
// export const BASE_URL = "http://localhost:8000/";
export const BASE_URL = "https://api.jagphotostudios.com/";
export const PDE = axios.create({ baseURL: BASE_URL });

